import React from "react"
import {Grid} from "@mui/material"
import PropTypes from "prop-types"
import Content from "../../../anwendungskonfigurator/components/Content"
import { cloneAndReplace, getMerkmal } from './../../../anwendungskonfigurator/misc/widget-functions';

const getSizeValue = (size) => {
    if (size === undefined) return undefined
    const castedSize = Number.parseInt(size)
    if (castedSize >= 1 && castedSize <= 12) return castedSize
    return undefined
}

const generateSizeObject = (container) => ({
    xs: getSizeValue(container.sizeXs),
    sm: getSizeValue(container.sizeSm),
    md: getSizeValue(container.sizeMd),
    lg: getSizeValue(container.sizeLg),
    xl: getSizeValue(container.sizeXl),
})

const ContainerFlexList = ({container,getDataFromPointer, disabled}) => {
    const {
        direction = "row",
        justifyContent = "flex-start",
        alignItems = "flex-start",
        containerSpacing,
    } = container
    const data = getDataFromPointer(getMerkmal(container)?.pointer)
    const entries = Array.isArray(data) ? data : []

    return (
        <Grid
            width="100%"
            container
            justifyContent={justifyContent}
            alignItems={alignItems}
            direction={direction}
            spacing={containerSpacing ? `${containerSpacing}px` : `0px`}>
            {entries?.map((dataEntry, index) => {
                const displayedContainers = container?.children?.map((entry) =>
                    cloneAndReplace(entry, index),
                )
                return displayedContainers?.map((child) => (
                    <Grid
                        key={child.id}
                        size={generateSizeObject(container)}>
                        <Content
                            child={child}
                            disabled={disabled}
                            payload={dataEntry}
                        />
                    </Grid>
                ))
            })}
        </Grid>
    )
}

ContainerFlexList.propTypes = {
    container: PropTypes.shape({
        direction: PropTypes.string,
        justifyContent: PropTypes.string,
        alignItems: PropTypes.string,
        spacing: PropTypes.string,
        sizeXs: PropTypes.string,
        sizeSm: PropTypes.string,
        sizeMd: PropTypes.string,
        sizeLg: PropTypes.string,
        sizeXl: PropTypes.string,
    }),
    disabled: PropTypes.bool,
}

export default ContainerFlexList
